import React from 'react';
import './About.css';
import DetailedBio from '../../components/DetailedBio/DetailedBio';
import QuoteBlock from '../../components/QuoteBlock/QuoteBlock';
import CTASection from '../../components/CTASection/CTASection';
import SectionHeader from '../../components/SectionHeader/SectionHeader';
import AboutDescription from '../../components/AboutDescription/AboutDescription';
import OurVision from '../../components/OurVision/OurVision';
import OurMission from '../../components/OurMission/OurMission';

const About = () => {
  return (
    <div className="about">
      <SectionHeader title="Welcome to Igbo-Eze North Local Government Council" />
      <AboutDescription />
      <DetailedBio />
      <OurVision />
      <OurMission />
      <QuoteBlock />
      <CTASection />
    </div>
  );
};

export default About;